// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"a86a5c75","454":"c943109b","840":"c943109b","870":"5fce4a31"}[chunkId] + ".chunk.css";
};